import { hotRanking } from '@/mocks/home';

export default function HotRanking() {
  const featured = hotRanking[0];
  const rest = hotRanking.slice(1);

  return (
    <section id="hot" className="bg-background-50 py-10 md:py-16 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6 md:mb-8">
          <div>
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">Hot Ranking</span>
            <h2 className="mt-1.5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">今日热度榜</h2>
            <p className="mt-1.5 text-sm text-foreground-500">按近 24 小时讨论量与新增条目的增速综合排序</p>
          </div>
          <a
            href="#feed"
            className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            全部榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-5 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="relative w-full aspect-[5/3]">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} 糖心小桃黑料爆料实锤`}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-3 left-3 w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                1
              </span>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800">{featured.tag}</span>
                <span className="inline-flex items-center gap-1 text-primary-600 font-label">
                  <i className="ri-fire-fill"></i>
                  {featured.heat}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-lg md:text-xl font-bold leading-snug text-foreground-950">
                {featured.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{featured.summary}</p>
              <a
                href="#timeline"
                className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看事件脉络
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </article>

          <div className="lg:col-span-7 flex flex-col gap-3">
            {rest.map((item, index) => (
              <article
                key={item.rank}
                className="flex gap-3 md:gap-4 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300 transition-colors"
              >
                <span className="w-7 text-center font-heading text-lg font-bold text-foreground-300 shrink-0 leading-tight">
                  {item.rank}
                </span>
                <div className="w-24 h-20 md:w-28 md:h-[76px] rounded-md overflow-hidden shrink-0 border border-background-200">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} 糖心小桃争议扒皮`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-sm md:text-base font-medium leading-snug text-foreground-900 line-clamp-2">
                      {item.title}
                    </h3>
                    <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px] whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="hidden sm:block mt-1 text-xs text-foreground-500 line-clamp-1">{item.summary}</p>
                  <div className="mt-2 flex items-center gap-3">
                    <span className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <span
                        className="block h-full rounded-full bg-primary-500"
                        style={{ width: `${Math.max(42, 94 - index * 13)}%` }}
                      ></span>
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-label whitespace-nowrap">
                      <i className={item.trend === 'down' ? 'ri-arrow-down-line' : item.trend === 'flat' ? 'ri-subtract-line' : 'ri-arrow-up-line'}></i>
                      {item.heat}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}